import React, { useRef } from 'react';
import { ScrollView } from 'react-native';

import PropTypes from 'prop-types';

import { VFScreen, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { ContentCard } from '../../Components';

import styles from './PrivacySettings.styles';

const PrivacySettings = props => {
  const { onClose, privacySettingsData, onActionItemPress, images } = props;
  const headerRef = useRef(null);
  const theme = useTheme();

  return (
    <VFScreen
      ref={headerRef}
      title="privacy_settings_title"
      onClose={onClose}
      headerStyle={styles.vfHeader(theme)}
      withHeaderSpace
    >
      <ScrollView
        showsVerticalScrollIndicator={false}
        contentContainerStyle={styles.contentContainer}
      >
        {!!privacySettingsData.header && (
          <VFText style={styles.header(theme)} i18nKey={privacySettingsData.header} />
        )}
        {privacySettingsData.contents.map((item, index) => (
          <ContentCard
            key={index}
            content={item}
            onActionItemPress={onActionItemPress}
            images={images}
          />
        ))}
      </ScrollView>
    </VFScreen>
  );
};

PrivacySettings.defaultProps = {
  onActionItemPress: () => {},
};

PrivacySettings.propTypes = {
  onClose: PropTypes.func.isRequired,
  privacySettingsData: PropTypes.object.isRequired,
  onActionItemPress: PropTypes.func,
  images: PropTypes.object.isRequired,
};

export default PrivacySettings;
